import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { bizCountries, api, categories, ngStates, go, logo, verifiedText, statusLabel } from './util';

/**
 * /businesses: the directory, laid out like Events. A bar (All / Verified, Add your business), moderators' and
 * your own businesses in boxes, a search field, industry chips (with how many are listed), a place row (country,
 * state, city), the cards, then Coverage: what's listed by industry and state, with the industries nobody has
 * listed in the chosen place shown as potential gaps.
 */
export default class BusinessList extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    const p = k => String(m.route.param(k) || '');
    this.f = {
      category: p('category'),
      sub: p('sub'),
      country: p('country'),
      state: p('state'),
      city: p('city'),
      place: p('place'),
      q: p('q'),
      verified: p('verified') === '1'
    };
    // /businesses?place=lagos: one location tag's businesses (a tag page's Useful links)
    if (!/^[a-z0-9_-]{1,100}$/i.test(this.f.place)) this.f.place = '';
    this.q = this.f.q;
    this.list = null;
    this.total = 0;
    this.coverage = null;
    this.more = false;
    this.mine = null;
    this.waiting = 0;
    if (app.session.user) this.loadMine();
    this.load();
  }
  loadMine() {
    app.request({
      method: 'GET',
      url: api('/me/businesses'),
      errorHandler: () => {}
    }).then(r => {
      this.mine = r.businesses || [];
      if (r.canModerate) {
        return app.request({
          method: 'GET',
          url: api('/businesses-queue'),
          errorHandler: () => {}
        }).then(q => this.waiting = (q.listings || []).length + (q.verifications || []).length);
      }
    }).catch(() => this.mine = this.mine || []).then(() => m.redraw());
  }
  answer(b, accept) {
    b.busy = true;
    app.request({
      method: accept ? 'POST' : 'DELETE',
      url: api('/businesses/' + b.id + (accept ? '/accept' : '/members/' + app.session.user.id())),
      errorHandler: () => {}
    }).then(r => this.mine = r.businesses || []).catch(() => b.busy = false).then(() => m.redraw());
  }
  query(extra) {
    const f = this.f;
    const parts = [];
    ['category', 'sub', 'country', 'state', 'city', 'place', 'q'].forEach(k => f[k] && parts.push(k + '=' + encodeURIComponent(f[k])));
    if (f.verified) parts.push('verified=1');
    if (extra) parts.push(extra);
    return parts.length ? '?' + parts.join('&') : '';
  }
  load(append) {
    if (!append) {
      this.list = null;
      const f = this.f;
      const place = ['country', 'state', 'city', 'place'].filter(k => f[k]).map(k => k + '=' + encodeURIComponent(f[k]));
      app.request({
        method: 'GET',
        url: api('/businesses/coverage') + (place.length ? '?' + place.join('&') : ''),
        errorHandler: () => {}
      }).then(r => this.coverage = r).catch(() => this.coverage = false).then(() => m.redraw());
    }
    this.loading = true;
    const offset = append && this.list ? this.list.length : 0;
    app.request({
      method: 'GET',
      url: api('/businesses') + this.query('offset=' + offset),
      errorHandler: () => {}
    }).then(r => {
      this.total = r.total || 0;
      this.list = (append && this.list ? this.list : []).concat(r.businesses || []);
    }).catch(() => this.list = this.list || []).then(() => {
      this.loading = false;
      m.redraw();
    });
  }
  set(patch) {
    Object.assign(this.f, patch);
    if ('category' in patch) this.f.sub = '';
    if ('country' in patch && patch.country !== 'NG') this.f.state = '';
    // the address keeps the filters, so a filtered directory can be shared
    window.history.replaceState(null, '', '/businesses' + this.query());
    this.load();
  }
  add() {
    if (!app.session.user) {
      const b = document.querySelector('.item-signUp .Button, .item-signUp button');
      if (b) b.click();
      return;
    }
    m.route.set('/businesses/new');
  }
  placeName() {
    const f = this.f;
    if (f.place) return this.coverage && this.coverage.place && this.coverage.place.name || f.place;
    if (f.city) return f.city;
    if (f.state) return (ngStates().find(s => String(s.id) === String(f.state)) || {}).name || 'this state';
    if (f.country) return (bizCountries(f.country).find(c => c[0] === f.country) || [null, f.country])[1];
    return null;
  }
  view() {
    const cats = categories();
    const cat = cats.find(c => c.key === this.f.category);
    const counts = {};
    (this.coverage && this.coverage.categories || []).forEach(c => counts[c.key] = c.count);
    const place = this.placeName();
    const filtered = this.f.category || this.f.country || this.f.city || this.f.place || this.f.q || this.f.verified;
    // industries: only the ones with businesses listed (in this place), and none at all when nothing is listed
    const shownCats = cats.filter(c => counts[c.key] || c.key === this.f.category);
    const chip = (on, label, n, onclick) => m("button", {
      type: "button",
      className: 'VouchaJoin-chip' + (on ? ' is-on' : ''),
      onclick: onclick
    }, label, n !== undefined ? m("small", null, n) : null);
    return m("div", {
      className: "VEvt VBiz"
    }, m("div", {
      className: "VEvt-top"
    }, m("div", {
      className: "VEvt-switch",
      role: "tablist"
    }, m("button", {
      type: "button",
      role: "tab",
      "aria-selected": this.f.verified ? 'false' : 'true',
      className: this.f.verified ? '' : 'is-on',
      onclick: () => this.f.verified && this.set({
        verified: false
      })
    }, "All"), m("button", {
      type: "button",
      role: "tab",
      "aria-selected": this.f.verified ? 'true' : 'false',
      className: this.f.verified ? 'is-on' : '',
      onclick: () => !this.f.verified && this.set({
        verified: true
      })
    }, m("i", {
      className: "fas fa-circle-check",
      "aria-hidden": "true"
    }), " Verified")), m(Button, {
      className: "Button Button--primary VEvt-create",
      icon: "fas fa-plus",
      onclick: () => this.add()
    }, "Add your business")), this.waiting ? m("section", {
      className: "VEvt-box VEvt-pending VBiz-waiting"
    }, m("h3", null, "Waiting for review (", this.waiting, ")"), m("p", null, "New listings and verification requests."), m(Button, {
      className: "Button Button--primary",
      onclick: go('/businesses/review')
    }, "Review")) : null, this.mine && this.mine.length ? m("section", {
      className: "VEvt-box"
    }, m("h3", null, "Your businesses"), m("div", {
      className: "VBiz-mine"
    }, this.mine.map(b => m("div", {
      className: "VBiz-mineRow"
    }, m("a", {
      href: '/businesses/' + b.slug,
      onclick: go('/businesses/' + b.slug)
    }, logo(b, 36), m("span", null, m("strong", null, b.name), m("small", null, b.myStatus === 'invited' ? 'Invited you to join as ' + (b.myRole === 'owner' ? 'an owner' : 'team') : b.myRole === 'owner' ? 'Owner' : 'Team'))), b.myStatus === 'invited' ? m("span", {
      className: "VEvt-actions"
    }, m(Button, {
      className: "Button Button--primary",
      loading: b.busy,
      onclick: () => this.answer(b, true)
    }, "Join"), m(Button, {
      className: "Button",
      disabled: b.busy,
      onclick: () => this.answer(b, false)
    }, "Decline")) : b.approval !== 'approved' ? m("span", {
      className: 'VEvt-status is-' + b.approval
    }, b.approval === 'pending' ? 'Waiting for approval' : 'Sent back') : b.verification && b.verification.status === 'verified' ? m("span", {
      className: "VBiz-badge VBiz-badge--verified"
    }, m("i", {
      className: "fas fa-circle-check"
    }), " Verified") : null)))) : null, m("form", {
      className: "VBiz-search",
      onsubmit: e => (e.preventDefault(), this.set({
        q: this.q.trim()
      }))
    }, m("i", {
      className: "fas fa-magnifying-glass",
      "aria-hidden": "true"
    }), m("input", {
      type: "search",
      placeholder: "Search businesses, services, products",
      value: this.q,
      oninput: e => this.q = e.target.value,
      onchange: e => this.set({
        q: e.target.value.trim()
      }),
      "aria-label": "Search businesses"
    })), shownCats.length ? m("div", {
      className: "VouchaJoin-chips VEvt-filters VBiz-chipsRow",
      role: "group",
      "aria-label": "Industry"
    }, chip(!this.f.category, 'All industries', undefined, () => this.set({
      category: ''
    })), shownCats.map(c => chip(this.f.category === c.key, c.name, counts[c.key] || undefined, () => this.set({
      category: this.f.category === c.key ? '' : c.key
    })))) : null, cat && cat.sub.length ? m("div", {
      className: "VouchaJoin-chips VEvt-filters VBiz-subRow",
      role: "group",
      "aria-label": cat.name
    }, chip(!this.f.sub, 'All of ' + cat.name, undefined, () => this.set({
      sub: ''
    })), cat.sub.map(s => chip(this.f.sub === s.key, s.name, undefined, () => this.set({
      sub: this.f.sub === s.key ? '' : s.key
    })))) : null, this.f.place ? m("div", {
      className: "VEvt-placeBar"
    }, m("span", null, m("i", {
      className: "fas fa-location-dot",
      "aria-hidden": "true"
    }), " Businesses in ", m("b", null, place)), m("button", {
      type: "button",
      className: "VEvt-placeClear",
      onclick: () => this.set({
        place: ''
      })
    }, "All businesses ", m("i", {
      className: "fas fa-xmark",
      "aria-hidden": "true"
    }))) : m("div", {
      className: "VBiz-placeRow"
    }, m("i", {
      className: "fas fa-location-dot",
      "aria-hidden": "true"
    }), m("select", {
      className: "VBiz-select",
      value: this.f.country,
      onchange: e => this.set({
        country: e.target.value
      }),
      "aria-label": "Country"
    }, m("option", {
      value: ""
    }, "Anywhere"), bizCountries(this.f.country).map(([code, name]) => m("option", {
      value: code
    }, name))), this.f.country === 'NG' ? m("select", {
      className: "VBiz-select",
      value: this.f.state,
      onchange: e => this.set({
        state: e.target.value
      }),
      "aria-label": "State"
    }, m("option", {
      value: ""
    }, "All states"), ngStates().map(s => m("option", {
      value: s.id
    }, s.name))) : null, this.f.country ? m("input", {
      className: "VBiz-select VBiz-city",
      type: "text",
      placeholder: "City",
      value: this.f.city,
      onchange: e => this.set({
        city: e.target.value.trim()
      }),
      "aria-label": "City"
    }) : null, filtered ? m("button", {
      type: "button",
      className: "VEvt-placeClear",
      onclick: () => (this.q = '', this.set({
        category: '',
        sub: '',
        country: '',
        state: '',
        city: '',
        place: '',
        q: '',
        verified: false
      }))
    }, "Clear ", m("i", {
      className: "fas fa-xmark",
      "aria-hidden": "true"
    })) : null), this.list === null ? m(LoadingIndicator, null) : this.list.length ? m("div", {
      className: "VBiz-results"
    }, m("p", {
      className: "VBiz-count"
    }, this.total === 1 ? '1 business' : this.total + ' businesses', place ? ' in ' + place : ''), m("div", {
      className: "VBiz-cards"
    }, this.list.map(b => this.card(b))), this.list.length < this.total ? m(Button, {
      className: "Button VBiz-more",
      loading: this.loading,
      onclick: () => this.load(true)
    }, "Show more") : null) : m("div", {
      className: "VEvt-empty"
    }, m("i", {
      className: "fas fa-store",
      "aria-hidden": "true"
    }), m("h3", null, filtered ? 'No businesses match' : 'No businesses listed yet', place ? ' in ' + place : ''), m("p", null, "Run a business", cat ? ' in ' + cat.name.toLowerCase() : '', place ? ' in ' + place : '', "? Add it, and members looking for it here will find you."), m(Button, {
      className: "Button Button--primary",
      onclick: () => this.add()
    }, "Add your business")), m("p", {
      className: "VEvt-note VBiz-hubLink"
    }, m("i", {
      className: "fas fa-chart-simple",
      "aria-hidden": "true"
    }), " Where businesses are listed, by industry and state:", ' ', m("a", {
      href: "/data-hub/businesses",
      onclick: go('/data-hub/businesses')
    }, "Data Hub \u203A Businesses")));
  }
  card(b) {
    const v = verifiedText(b.verification);
    const years = b.yearsOperating ? b.yearsOperating + (b.yearsOperating === 1 ? ' year' : ' years') : null;
    return m("a", {
      className: "VEvt-card VBiz-card",
      href: '/businesses/' + b.slug,
      onclick: go('/businesses/' + b.slug)
    }, logo(b, 72), m("span", {
      className: "VEvt-cardText"
    }, m("span", {
      className: "VEvt-cardTime"
    }, [b.category && b.category.name, b.place].filter(Boolean).join(' · ')), m("strong", {
      className: "VEvt-cardTitle"
    }, b.name, v ? m("i", {
      className: "fas fa-circle-check VBiz-tick",
      title: v,
      "aria-label": "Verified"
    }) : null), b.about ? m("span", {
      className: "VBiz-about"
    }, b.about) : null, m("span", {
      className: "VEvt-cardMeta"
    }, m("i", {
      className: "fas fa-thumbs-up",
      "aria-hidden": "true"
    }), " ", b.vouchCount === 1 ? '1 vouch' : b.vouchCount + ' vouches', years ? [' · ', m("i", {
      className: "far fa-clock",
      "aria-hidden": "true"
    }), ' ', years] : null, b.operatingStatus !== 'operating' ? ' · ' + statusLabel[b.operatingStatus] : '')));
  }
}
flarum.reg.add('voucha-community', 'forum/businesses/BusinessList', BusinessList);